export default function Hero() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://www.britishtailors.com/wp-content/uploads/2016/06/img1.jpg"
          alt="Luxury custom tailored suits"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Exquisite Custom Tailoring
            <span className="block text-[#C9A961] mt-2">Crafted for You</span>
          </h1>
          
          <p className="text-xl sm:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            Experience the perfect fit with handcrafted custom suits and shirts. 
            <strong className="text-white"> Nationwide house calls available</strong> for your convenience.
          </p>

          {/* Trust Badges */}
          <div className="flex flex-wrap justify-center items-center gap-6 mb-10 text-white/90">
            <div className="flex items-center space-x-2">
              <i className="ri-star-fill text-[#C9A961] text-xl"></i>
              <span className="text-sm font-medium whitespace-nowrap">5.0 Rating</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line text-[#C9A961] text-xl"></i>
              <span className="text-sm font-medium whitespace-nowrap">Masterfully Tailored</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-time-line text-[#C9A961] text-xl"></i>
              <span className="text-sm font-medium whitespace-nowrap">6 to 8 weeks*</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="#consultation" 
              className="bg-[#C9A961] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#B89851] transition-all duration-300 shadow-2xl hover:shadow-[#C9A961]/50 hover:scale-105 whitespace-nowrap"
            >
              Call for Appointment
            </a>
            <a 
              href="tel:866-857-8487" 
              className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/20 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call 866-857-8487
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <a href="#trust-bar" className="text-white/70 hover:text-white transition-colors">
          <i className="ri-arrow-down-line text-3xl"></i>
        </a>
      </div>
    </section>
  );
}